// extracted by mini-css-extract-plugin
module.exports = {"signup-form":"styles_signup-form__2hSKi","message":"styles_message__2UkwX","email-input":"styles_email-input__39rj2","signup-button":"styles_signup-button__240Ev"};